import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Fab, FormControl, FormHelperText, Grid, InputLabel, makeStyles, 
    MenuItem, Paper, Select, TextField, Theme, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, 
    Divider, useTheme, useMediaQuery } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import ExitIcon from '@material-ui/icons/Clear';
import LaunchIcon from '@material-ui/icons/Launch';
import { createStyles } from '@material-ui/styles';
import { useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { SectionTitle } from '../../components/SectionTitle';
//HACK vmorell 20210327 after typescript 4.0.3 forced TipoImpresaProps per avere un tipo inizializzato nello state
import { TipoImpresa, TipoImpresaProps } from '../../components/TipoImpresa';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import SchedaBudgetDataClass from "../../states/BudgetState";
import { API_elaboraSchedaBudget, calcolaRedditivita, GestParseFloatNaN } from '../../utils/functions';
import IscrizioneImpreseArtigiane from './IscrizioneImpreseArtigiane';
import IscrizioneRegistroImprese from './IscrizioneRegistroImprese';
import { breakpoint } from '../../types/constants';
// import { TipoImpresa } from '../../types/types';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        // root: {
        //     flexGrow: 1,
        // },
        expandRoot: {
            backgroundColor: 'rgba(0, 0, 0, .03)',
            borderBottom: '1px solid rgba(0, 0, 0, .125)',
            marginBottom: -1,
          },
    }),
);

export type SchedaBudgetInputProps = {
    state: SchedaBudgetDataClass;
    username?: string;
    handleChange?: any;
}

export default function InformazioniCosti(props: SchedaBudgetInputProps) {
    const theme = useTheme(); 
    const classes = useStyles();
    const gClasses = globalStyles();
    const [global] = useGlobal<IGlobalState>();
    const [showResetWarning, setShowResetWarning] = useState(false);
    //HACK vmorell 20210327 after typescript 4.0.3 forced TipoImpresaProps per avere un tipo inizializzato
    const [tipoImpresa, setTipoImpresa] = useState<TipoImpresaProps>({name: '', value: ''});
    const [firstSet, setFirstSet] = useState(true);
    const action = "changeInformazioniCostiBudget";
    const { state } = props;
    const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));

    const [RegistroImpreseDialogOpen, SetRegistroImpreseDialogOpen] = useState(false);
    const [AlboArtigianiOpen, SetAlboArtigianiOpen] = useState(false);

    let errorRegime = state.informazioniCostiDiAvvio.regime === (undefined || "" || "NON DEFINITO" || null);
    let errorNomeDitta = state.informazioniCostiDiAvvio.nomeDitta === (undefined || "" || null);
    let isImpresaForfetizabile = (state.informazioniCostiDiAvvio.tipologia === "IMPRESA" ||
        state.informazioniCostiDiAvvio.tipologia === "IMPRESA_FAMILIARE" ||
        state.informazioniCostiDiAvvio.tipologia === "PROFESSIONE");

    function handleDialogConferma() {
        // console.log('Tipo impresa FixMe');
        setShowResetWarning(false);
        props.handleChange("reset", "", "");
        props.handleChange(action, tipoImpresa.name, tipoImpresa.value);
    }

    function handleDialogAnnulla() {
        setShowResetWarning(false);
    }

    const handleChange = (e: any) => {
        // console.log("chiamata handleChange");
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraSchedaBudget(props, global, name, value, action, true);
    }

    const handleChangeTipologia = (e: any) => {
        // console.log('ChangeTipologia FixMe');
        let { name, value } = e.target;
        console.log({name});
        console.log({value});

        if (!firstSet) {
            setShowResetWarning(true);
        }
        else {
            setFirstSet(false);
            props.handleChange(action, name, value);
        }
        setTipoImpresa({ name, value });
        // API_elaboraSchedaBudget(props, global, name, value, action, true);
    }

    const handleChangeChild = (act: string, name: string, value: any) => {
        props.handleChange(act, name, value);
    }

    const handleBlur = () => {
        API_elaboraSchedaBudget(props, global);
    }

    const handleClose = (e: any) => {
        SetRegistroImpreseDialogOpen(false);
        SetAlboArtigianiOpen(false);
        handleBlur();
    }

    const apriModal = (e: number) => {
        if (e === 0) {
            SetRegistroImpreseDialogOpen(true);
        }
        else if (e === 1) {
            SetAlboArtigianiOpen(true);
        }
    }

    return (
        <Paper className={gClasses.mainPaper}>
            <Dialog
                open={RegistroImpreseDialogOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{<Typography variant="h5" color="primary">Albo imprese artigiane / diritto di iscrizione</Typography>}</DialogTitle>
                <DialogContent dividers>
                    <IscrizioneRegistroImprese handleChange={handleChangeChild} state={state} />
                </DialogContent>
                <DialogActions>
                    <Fab onClick={handleClose}>
                        <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi" />
                    </Fab>
                </DialogActions>
            </Dialog>
            <Dialog
                open={AlboArtigianiOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{<Typography variant="h5" color="primary">Iscrizione registro imprese / diritto di segreteria</Typography>}</DialogTitle>
                <DialogContent dividers>
                    <IscrizioneImpreseArtigiane handleChange={handleChangeChild} state={state} />
                </DialogContent>
                <DialogActions>
                    <Fab onClick={handleClose}>
                        <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi" />
                    </Fab>
                </DialogActions>
            </Dialog>
            <Dialog
                open={showResetWarning}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{<Typography variant="h5" color="primary">Attenzione</Typography>}</DialogTitle>
                <DialogContent dividers>
                    <Typography>La modifica di uno di questi campi comporta il reset della simulazione impostata fin'ora.</Typography>

                    <Typography>Procedere comunque?</Typography>
                </DialogContent>
                <DialogActions>
                    <Fab onClick={handleDialogConferma}>
                        <CheckIcon style={{ width: '2rem', height: '2rem' }} color="primary" titleAccess="Procedi" />
                    </Fab>
                    <Fab onClick={handleDialogAnnulla}>
                        <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Annulla" />
                    </Fab>
                </DialogActions>
            </Dialog>
            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
            >
                <SectionTitle text="Informazioni iniziali"></SectionTitle>
                <Grid container spacing={1} direction="row" justify="flex-start" alignItems="center">
                    <Grid item >
                        <TextField
                            name="nomeDitta"
                            label="Nome ditta"
                            error={errorNomeDitta}
                            helperText={errorNomeDitta ? "Campo obbligatorio" : ""}
                            value={state.informazioniCostiDiAvvio.nomeDitta}
                            className={gClasses.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item >
                        <TextField
                            name="attivita"
                            label="Attività"
                            value={state.informazioniCostiDiAvvio.attivita}
                            className={gClasses.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1} direction="row" justify="flex-start" alignItems="center">
                    <Grid item>
                        <TipoImpresa
                            value={state.informazioniCostiDiAvvio.tipologia}
                            onChange={handleChangeTipologia}
                            // onBlur={handleBlur}
                            name="tipologia"
                        />
                    </Grid>
                    <Grid item>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="regime">Regime fiscale</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.informazioniCostiDiAvvio.regime}
                                onChange={handleChangeSelect}
                                error={errorRegime}
                                inputProps={{
                                    name: 'regime',
                                    id: 'regime',
                                }}
                            >
                                <MenuItem value={"NORMALE"}>Normale</MenuItem>
                                {(isImpresaForfetizabile ?
                                    <MenuItem value={"FORFETARIO"}>Forfetario</MenuItem> : "")}
                            </Select>
                            <FormHelperText error={errorRegime}>
                                {errorRegime ? "Campo obbligatorio" : ""}</FormHelperText>
                        </FormControl>
                    </Grid>
                </Grid>
                <SectionTitle text="Costi"></SectionTitle>
                <Grid item xs={12}>
                    <SectionSubTitle text="Investimenti"></SectionSubTitle>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <NumberField
                            name="E16_fabbricato"
                            label="Fabbricato"
                            value={state.informazioniCostiDiAvvio.E16_fabbricato}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            tooltip="Capannone, Laboratorio, Negozio, eccetera"
                        />
                        <NumberField
                            name="E17_macchinari"
                            label="Macchinari"
                            value={state.informazioniCostiDiAvvio.E17_macchinari}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                        <NumberField
                            name="E18_attrezzature"
                            label="Attrezzature"
                            value={state.informazioniCostiDiAvvio.E18_attrezzature}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                        <NumberField
                            name="E19_macchinari"
                            label="Impianti"
                            value={state.informazioniCostiDiAvvio.E19_macchinari}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                        <NumberField
                            name="E20_mobili"
                            label="Macchine e mobili d'ufficio"
                            value={state.informazioniCostiDiAvvio.E20_mobili}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                        <NumberField
                            name="E21_furgoni"
                            label="Furgoni, autocarri, ecc."
                            value={state.informazioniCostiDiAvvio.E21_furgoni}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                        <NumberField
                            name="E22_autovetture"
                            label="Autovetture"
                            value={state.informazioniCostiDiAvvio.E22_autovetture}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                        <NumberField
                            name="E23_immateriali"
                            label="Beni immateriali"
                            value={state.informazioniCostiDiAvvio.E23_immateriali}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                        <NumberField
                            name="E24_altro"
                            label="Altro"
                            value={state.informazioniCostiDiAvvio.E24_altro}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <NumberField
                            name="E25_totale"
                            label="Totale investimenti"
                            value={state.informazioniCostiDiAvvio.E25_totale}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <SectionSubTitle text="Spese di avvio"></SectionSubTitle>
                </Grid>
                <Grid container
                    direction="row"
                    justify="flex-start"
                    alignItems="flex-start" spacing={1}>
                    <Grid item xs={6}> {/* Contratto d'acquisto azienda */}
                        <Typography className={gClasses.boldLabel} variant="h6">Contratto d'acquisto azienda</Typography>
                        <NumberField
                            name="E37_speseVive_AcquistoAzienda"
                            value={state.informazioniCostiDiAvvio.E37_speseVive_AcquistoAzienda}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            label="Spese vive"
                        />
                        <NumberField
                            className={gClasses.textField}
                            name="F37_consEst_AcquistoAzienda"
                            value={state.informazioniCostiDiAvvio.F37_consEst_AcquistoAzienda}
                            label="Consulenze e provvigioni"
                            onBlur={handleBlur} onChange={handleChange}
                        />
                        <NumberField
                            className={gClasses.textField}
                            name="I37_consInt_AcquistoAzienda"
                            value={state.informazioniCostiDiAvvio.I37_consInt_AcquistoAzienda}
                            label="Consulenze interne"
                            onBlur={handleBlur} onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={6}> {/* Contratto d'affitto azienda */}
                        <Typography className={gClasses.boldLabel} variant="h6">Contratto d'affitto azienda</Typography>
                        <NumberField
                            name="E38_speseVive_AffittoAzienda"
                            value={state.informazioniCostiDiAvvio.E38_speseVive_AffittoAzienda}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            label="Spese vive"
                        />
                        <NumberField
                            className={gClasses.textField}
                            name="F38_consEst_AffittoAzienda"
                            value={state.informazioniCostiDiAvvio.F38_consEst_AffittoAzienda}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            label="Consulenze e provvigioni"
                        />
                        <NumberField
                            className={gClasses.textField}
                            name="I38_consInt_AffittoAzienda"
                            value={state.informazioniCostiDiAvvio.I38_consInt_AffittoAzienda}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            label="Consulenze interne"
                        />
                    </Grid>
                    <Grid item xs={6}> {/* Atto costitutivo Società */}
                        <Typography className={gClasses.boldLabel} variant="h6">Atto costitutivo Società</Typography>
                        <NumberField
                            name="E39_speseVive_AttoCostSocieta"
                            value={state.informazioniCostiDiAvvio.E39_speseVive_AttoCostSocieta}
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            label="Spese vive"
                        />
                        <NumberField
                            className={gClasses.textField}
                            name="F39_consEst_AttoCostSocieta"
                            value={state.informazioniCostiDiAvvio.F39_consEst_AttoCostSocieta}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            label="Consulenze e provvigioni"
                        />
                        <NumberField
                            className={gClasses.textField}
                            name="I39_consInt_AttoCostSocieta"
                            value={state.informazioniCostiDiAvvio.I39_consInt_AttoCostSocieta}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            label="Consulenze interne"
                        />
                    </Grid>
                    <Grid item xs={6}> {/* Contratto di locazione o di acquisto dei locali */}
                        <Typography className={gClasses.boldLabel} variant="h6">Contratto di locazione o di acquisto dei locali</Typography>
                        <NumberField
                            name="E43_speseVive_Locali"
                            value={state.informazioniCostiDiAvvio.E43_speseVive_Locali}
                            className={gClasses.textField}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label="Spese vive"
                        />
                        <NumberField
                            name="F43_consEst_Locali"
                            className={gClasses.textField}
                            value={state.informazioniCostiDiAvvio.F43_consEst_Locali}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label="Consulenze e provvigioni"
                        />
                        <NumberField
                            name="I43_consInt_Locali"
                            className={gClasses.textField}
                            value={state.informazioniCostiDiAvvio.I43_consInt_Locali}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label="Consulenze interne"
                        />
                    </Grid>
                    <Grid item xs={6}> {/* Iscrizione albo Artigiani */}
                        <Button onClick={() => apriModal(1)} style={{ cursor: "pointer", marginTop: "10px" }}>
                            <React.Fragment>
                                <Typography variant="h6" style={{ textTransform: "none" }}>Iscrizione Registro Imprese</Typography>
                                <LaunchIcon style={{ marginLeft: "5px", marginBottom: "5px", height: "17px" }} color="secondary"></LaunchIcon>
                            </React.Fragment>
                        </Button>
                        <Grid container direction="row">
                            <NumberField
                                name="E41_speseVive_IscrizioneAlbo"
                                value={state.informazioniCostiDiAvvio.E41_speseVive_IscrizioneAlbo}
                                className={gClasses.textFieldReadOnly}
                                readOnly={true}
                                label="Spese vive"
                                style={{ cursor: "pointer" }}
                            />
                            <NumberField
                                name="F41_consEst_IscrizioneAlbo"
                                className={gClasses.textField}
                                value={state.informazioniCostiDiAvvio.F41_consEst_IscrizioneAlbo}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label="Consulenze e provvigioni"
                            />
                            <NumberField
                                name="I41_consInt_IscrizioneAlbo"
                                className={gClasses.textField}
                                value={state.informazioniCostiDiAvvio.I41_consInt_IscrizioneAlbo}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label="Consulenze interne"
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6}> {/* Iscrizione Registro Imprese*/}
                        <Button onClick={() => apriModal(0)} style={{ cursor: "pointer", marginTop: "10px" }}>
                            <React.Fragment>
                                <Typography variant="h6" style={{ textTransform: "none" }}>Iscrizione albo Artigiani</Typography>
                                <LaunchIcon style={{ marginLeft: "5px", marginBottom: "5px", height: "17px" }}  color="secondary" ></LaunchIcon>
                            </React.Fragment>
                        </Button>
                        <Grid container direction="row">
                            <NumberField
                                name="E40_speseVive_IscrizioneRegistroImprese"
                                value={state.informazioniCostiDiAvvio.E40_speseVive_IscrizioneRegistroImprese}
                                className={gClasses.textFieldReadOnly}
                                readOnly={true}
                                label="Spese vive"
                                style={{ cursor: "pointer" }}
                            />
                            <NumberField
                                className={gClasses.textField}
                                name="F40_consEst_IscrizioneRegistroImprese"
                                value={state.informazioniCostiDiAvvio.F40_consEst_IscrizioneRegistroImprese}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label="Consulenze e provvigioni"
                            />
                            <NumberField
                                className={gClasses.textField}
                                name="I40_consInt_IscrizioneRegistroImprese"
                                value={state.informazioniCostiDiAvvio.I40_consInt_IscrizioneRegistroImprese}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label="Consulenze interne"
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6}> {/* Autorizzazioni/Permessi*/}
                        <Typography className={gClasses.boldLabel} variant="h6">Autorizzazioni/Permessi</Typography>
                        <NumberField
                            name="E42_speseVive_AutorizzazioniPermessi"
                            value={state.informazioniCostiDiAvvio.E42_speseVive_AutorizzazioniPermessi}
                            className={gClasses.textField}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label="Spese vive"
                        />
                        <NumberField
                            name="F42_consEst_AutorizzazioniPermessi"
                            className={gClasses.textField}
                            value={state.informazioniCostiDiAvvio.F42_consEst_AutorizzazioniPermessi}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label="Consulenze e provvigioni"
                        />
                        <NumberField
                            name="I42_consInt_AutorizzazioniPermessi"
                            className={gClasses.textField}
                            value={state.informazioniCostiDiAvvio.I42_consInt_AutorizzazioniPermessi}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label="Consulenze interne"
                        />
                    </Grid>
                    
                    <ExpansionPanel style={{ margin: "0.5rem" }}>
                        <ExpansionPanelSummary
                        className={classes.expandRoot} 
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography style={{ width: "15rem" }} variant="h6">Spese di consulenza</Typography>
                            {/* Al posto di Direction row metto direction column */}
                            <Grid container direction={mobile ? 'column' : 'row'} justify="space-evenly">
                                <Typography style={{ margin: "5px", marginLeft: "2rem" }}>
                                    Spese vive: {GestParseFloatNaN(state.informazioniCostiDiAvvio.E44_speseVive_Privacy) + GestParseFloatNaN(state.informazioniCostiDiAvvio.E45_speseVive_Dlgs812008)
                                        + GestParseFloatNaN(state.informazioniCostiDiAvvio.E46_speseVive_HACCP) + GestParseFloatNaN(state.informazioniCostiDiAvvio.E47_speseVive_Ambiente)
                                        + GestParseFloatNaN(state.informazioniCostiDiAvvio.E48_speseVive_Informatici)}</Typography>
                                <Typography style={{ margin: "5px", marginLeft: "5px" }}>
                                    Cons. e provvigioni: {GestParseFloatNaN(state.informazioniCostiDiAvvio.F44_consEst_Privacy) + GestParseFloatNaN(state.informazioniCostiDiAvvio.F45_consEst_Dlgs812008)
                                        + GestParseFloatNaN(state.informazioniCostiDiAvvio.F46_consEst_HACCP) + GestParseFloatNaN(state.informazioniCostiDiAvvio.F47_consEst_Ambiente)
                                        + GestParseFloatNaN(state.informazioniCostiDiAvvio.F48_consEst_Informatici)}</Typography>
                                <Typography style={{ margin: "5px", marginLeft: "5px" }}>
                                    Cons. interne: {GestParseFloatNaN(state.informazioniCostiDiAvvio.I44_consInt_Privacy) + GestParseFloatNaN(state.informazioniCostiDiAvvio.I45_consInt_Dlgs812008)
                                        + GestParseFloatNaN(state.informazioniCostiDiAvvio.I46_consInt_HACCP) + GestParseFloatNaN(state.informazioniCostiDiAvvio.I47_consInt_Ambiente)
                                        + GestParseFloatNaN(state.informazioniCostiDiAvvio.I48_consInt_Informatici)}</Typography>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            {mobile ?
                            <>
                                <Grid container xs={12} >
                                <Grid item xs={12}>
                                    <Typography className={gClasses.boldLabel} variant="h6">Privacy</Typography>
                                    <NumberField
                                        name="E44_speseVive_Privacy"
                                        value={state.informazioniCostiDiAvvio.E44_speseVive_Privacy}
                                        className={gClasses.textField}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Spese vive"
                                    />
                                    <NumberField
                                        name="F44_consEst_Privacy"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.F44_consEst_Privacy}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze e provvigioni"
                                    />
                                    <NumberField
                                        name="I44_consInt_Privacy"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.I44_consInt_Privacy}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze interne"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography className={gClasses.boldLabel} variant="h6">D.Lgs. 81/2008</Typography>
                                    <NumberField
                                        name="E45_speseVive_Dlgs812008"
                                        value={state.informazioniCostiDiAvvio.E45_speseVive_Dlgs812008}
                                        className={gClasses.textField}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Spese vive"
                                    />
                                    <NumberField
                                        name="F45_consEst_Dlgs812008"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.F45_consEst_Dlgs812008}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze e provvigioni"
                                    />
                                    <NumberField
                                        name="I45_consInt_Dlgs812008"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.I45_consInt_Dlgs812008}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze interne"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography className={gClasses.boldLabel} variant="h6">HACCP</Typography>
                                    <NumberField
                                        name="E46_speseVive_HACCP"
                                        value={state.informazioniCostiDiAvvio.E46_speseVive_HACCP}
                                        className={gClasses.textField}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Spese vive"
                                    />
                                    <NumberField
                                        name="F46_consEst_HACCP"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.F46_consEst_HACCP}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze e provvigioni"
                                    />
                                    <NumberField
                                        name="I46_consInt_HACCP"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.I46_consInt_HACCP}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze interne"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography className={gClasses.boldLabel} variant="h6">Ambiente</Typography>
                                    <NumberField
                                        name="E47_speseVive_Ambiente"
                                        value={state.informazioniCostiDiAvvio.E47_speseVive_Ambiente}
                                        className={gClasses.textField}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Spese vive"
                                    />
                                    <NumberField
                                        name="F47_consEst_Ambiente"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.F47_consEst_Ambiente}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze e provvigioni"
                                    />
                                    <NumberField
                                        name="I47_consInt_Ambiente"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.I47_consInt_Ambiente}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze interne"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography className={gClasses.boldLabel} variant="h6">Informatica</Typography>
                                    <NumberField
                                        name="E48_speseVive_Informatici"
                                        value={state.informazioniCostiDiAvvio.E48_speseVive_Informatici}
                                        className={gClasses.textField}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Spese vive"
                                    />
                                    <NumberField
                                        name="F48_consEst_Informatici"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.F48_consEst_Informatici}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze e provvigioni"
                                    />
                                    <NumberField
                                        name="I48_consInt_Informatici"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.I48_consInt_Informatici}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze interne"
                                    />
                                </Grid>
                                </Grid>
                            </>
                            :
                            <>
                                <Grid item xs={12}>
                                    <Typography className={gClasses.boldLabel} variant="h6">Privacy</Typography>
                                    <NumberField
                                        name="E44_speseVive_Privacy"
                                        value={state.informazioniCostiDiAvvio.E44_speseVive_Privacy}
                                        className={gClasses.textField}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Spese vive"
                                    />
                                    <NumberField
                                        name="F44_consEst_Privacy"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.F44_consEst_Privacy}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze e provvigioni"
                                    />
                                    <NumberField
                                        name="I44_consInt_Privacy"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.I44_consInt_Privacy}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze interne"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography className={gClasses.boldLabel} variant="h6">D.Lgs. 81/2008</Typography>
                                    <NumberField
                                        name="E45_speseVive_Dlgs812008"
                                        value={state.informazioniCostiDiAvvio.E45_speseVive_Dlgs812008}
                                        className={gClasses.textField}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Spese vive"
                                    />
                                    <NumberField
                                        name="F45_consEst_Dlgs812008"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.F45_consEst_Dlgs812008}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze e provvigioni"
                                    />
                                    <NumberField
                                        name="I45_consInt_Dlgs812008"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.I45_consInt_Dlgs812008}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze interne"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography className={gClasses.boldLabel} variant="h6">HACCP</Typography>
                                    <NumberField
                                        name="E46_speseVive_HACCP"
                                        value={state.informazioniCostiDiAvvio.E46_speseVive_HACCP}
                                        className={gClasses.textField}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Spese vive"
                                    />
                                    <NumberField
                                        name="F46_consEst_HACCP"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.F46_consEst_HACCP}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze e provvigioni"
                                    />
                                    <NumberField
                                        name="I46_consInt_HACCP"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.I46_consInt_HACCP}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze interne"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography className={gClasses.boldLabel} variant="h6">Ambiente</Typography>
                                    <NumberField
                                        name="E47_speseVive_Ambiente"
                                        value={state.informazioniCostiDiAvvio.E47_speseVive_Ambiente}
                                        className={gClasses.textField}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Spese vive"
                                    />
                                    <NumberField
                                        name="F47_consEst_Ambiente"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.F47_consEst_Ambiente}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze e provvigioni"
                                    />
                                    <NumberField
                                        name="I47_consInt_Ambiente"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.I47_consInt_Ambiente}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze interne"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography className={gClasses.boldLabel} variant="h6">Informatica</Typography>
                                    <NumberField
                                        name="E48_speseVive_Informatici"
                                        value={state.informazioniCostiDiAvvio.E48_speseVive_Informatici}
                                        className={gClasses.textField}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Spese vive"
                                    />
                                    <NumberField
                                        name="F48_consEst_Informatici"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.F48_consEst_Informatici}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze e provvigioni"
                                    />
                                    <NumberField
                                        name="I48_consInt_Informatici"
                                        className={gClasses.textField}
                                        value={state.informazioniCostiDiAvvio.I48_consInt_Informatici}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        label="Consulenze interne"
                                    />
                                </Grid>
                            </>
                            }
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel style={{ margin: "0.5rem" }}>
                        <ExpansionPanelSummary
                            className={classes.expandRoot} 
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography style={{ width: "15rem" }} variant="h6">Altre spese</Typography>
                            <Grid container direction="row" justify="space-evenly">
                            
                                <Typography style={{ margin: "5px", marginLeft: "2rem" }}>
                                    Spese vive: {GestParseFloatNaN(state.informazioniCostiDiAvvio.E49_speseVive_Altro1) + GestParseFloatNaN(state.informazioniCostiDiAvvio.E50_speseVive_Altro2)}</Typography>
                                <Typography style={{ margin: "5px", marginLeft: "5px" }}>
                                    Cons. e provvigioni: {GestParseFloatNaN(state.informazioniCostiDiAvvio.F49_consEst_Altro1) + GestParseFloatNaN(state.informazioniCostiDiAvvio.F50_consEst_Altro2)}</Typography>
                                <Typography style={{ margin: "5px", marginLeft: "5px" }}>
                                    Cons. interne: {GestParseFloatNaN(state.informazioniCostiDiAvvio.I49_consInt_Altro1) + GestParseFloatNaN(state.informazioniCostiDiAvvio.I50_consInt_Altro2)}</Typography>
                            </Grid>
                            
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <React.Fragment>
                                <Grid container xs={12}>
                                    <TextField
                                        name="altro1"
                                        label="Descrizione spesa"
                                        className={gClasses.textField}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        margin="normal"
                                    />
                                    <Grid item xs={12} direction="column">
                                        <NumberField
                                            name="E49_speseVive_Altro1"
                                            value={state.informazioniCostiDiAvvio.E49_speseVive_Altro1}
                                            className={gClasses.textField}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Spese vive"
                                        />
                                        <NumberField
                                            name="F49_consEst_Altro1"
                                            className={gClasses.textField}
                                            value={state.informazioniCostiDiAvvio.F49_consEst_Altro1}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Consulenze e provvigioni"
                                        />
                                        <NumberField
                                            name="I49_consInt_Altro1"
                                            className={gClasses.textField}
                                            value={state.informazioniCostiDiAvvio.I49_consInt_Altro1}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Consulenze interne"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container xs={12}>
                                    <TextField
                                        name="altro2"
                                        label="Descrizione spesa"
                                        className={gClasses.textField}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        margin="normal"
                                    />
                                    <Grid item xs={12} direction="column">
                                        <NumberField
                                            name="E50_speseVive_Altro2"
                                            value={state.informazioniCostiDiAvvio.E50_speseVive_Altro2}
                                            className={gClasses.textField}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Spese vive"
                                        />
                                        <NumberField
                                            name="F50_consEst_Altro2"
                                            className={gClasses.textField}
                                            value={state.informazioniCostiDiAvvio.F50_consEst_Altro2}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Consulenze e provvigioni"
                                        />
                                        <NumberField
                                            name="I50_consInt_Altro2"
                                            className={gClasses.textField}
                                            value={state.informazioniCostiDiAvvio.I50_consInt_Altro2}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Consulenze interne"
                                        />
                                    </Grid>
                                </Grid>
                            </React.Fragment>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <Grid item xs={12}>
                        <Typography className={gClasses.boldLabel} variant="h6">Parziali</Typography>
                        <NumberField
                            name="E51_parziali_spese_vive"
                            value={state.informazioniCostiDiAvvio.E51_parziali_spese_vive}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                            label="Spese vive"
                        />
                        <NumberField
                            name="F51_consulenze_esterne_provvigioni"
                            className={gClasses.textFieldReadOnly}
                            value={state.informazioniCostiDiAvvio.F51_consulenze_esterne_provvigioni}
                            readOnly={true}
                            label="Consulenze e provvigioni"
                        />
                        <NumberField
                            name="I51_consulenze_interne"
                            className={gClasses.textFieldReadOnly}
                            value={state.informazioniCostiDiAvvio.I51_consulenze_interne}
                            readOnly={true}
                            label="Consulenze interne"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography className={gClasses.boldLabel} variant="h6">Totale costi iniziali</Typography>
                        <NumberField
                            name="E52_totale_costi_iniziali"
                            value={state.informazioniCostiDiAvvio.E52_totale_costi_iniziali}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                            label="Totale spese"
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Paper >
    )
}